var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComputer = function SvgComputer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.667 21.667h26.666V3.333H3.667zm15 3.333v3.333h6.666v3.334H8.667v-3.334h6.666V25H1.986a1.664 1.664 0 0 1-1.653-1.68V1.68C.333.751 1.093 0 1.986 0h30.028c.913 0 1.653.748 1.653 1.68v21.64c0 .928-.76 1.68-1.653 1.68z"
  })));
};
export default SvgComputer;